<template>
  <div>
    <article class="con5">
      <p>실제 학습자가 남기는<br />당근 중국어의 생생한 후기</p>
      <div class="con5-slide">
        <VueSlickCarousel ref="carousel" v-bind="settings" @init="handleInit">
          <div>
            <div class="icon-name">
              <img src="@/assets/img/chinese/index/con5/icon1.png" alt="icon" />
              <p>김*현 님</p>
            </div>
            <p>중국어는 어렵다는<br />선입견을 깨준<br />수업이에요</p>
            <p>
              중국어는 발음과 억양이 복잡해서 어렵다고 생각하고 있었는데, 원어민
              강사님이 천천히 차근차근 가르쳐 주시니 이해가 쏙쏙 되니 오히려
              자신감이 생겼어요.
            </p>
          </div>
          <div>
            <div class="icon-name">
              <img src="@/assets/img/chinese/index/con5/icon2.png" alt="icon" />
              <p>정*범 님</p>
            </div>
            <p>자막 없이<br />중국 드라마 보기<br />시작했어요!</p>
            <p>
              드라마를 자막 없이 보고 싶어서 당근 중국어 시작했어요. 원어민
              강사님과 드라마 얘기도 하고 드라마 속 대사 표현을 이해하기 쉽게
              가르쳐 주셔서 수업이 너무 재미있어요.
            </p>
          </div>
          <div>
            <div class="icon-name">
              <img src="@/assets/img/chinese/index/con5/icon3.png" alt="icon" />
              <p>주*훈 님</p>
            </div>
            <p>당근 중국어 덕분에<br />BCT 목표 점수<br />달성했어요</p>
            <p>
              시험 대비를 위해 학원을 찾다가 당근 중국어를 알게 되었어요. 원어민
              강사님이 시험에 대한 이해가 높으시고 전략적인 방법을 알려주셔서
              목표 점수를 취득할 수 있었어요.
            </p>
          </div>
          <div>
            <div class="icon-name">
              <img src="@/assets/img/chinese/index/con5/icon1.png" alt="icon" />
              <p>현*수 님</p>
            </div>
            <p>역시 외국어는<br />그 나라 사람한테<br />배워야 하나 봅니다</p>
            <p>
              아무리 강의를 들어도 늘지 않았던 중국어가 이제야 말문이
              트였습니다. 역시 외국어는 그 나라 사람한테 배워야 하는 게 진리인
              것 같아요. 강력 추천합니다!
            </p>
          </div>
          <div>
            <div class="icon-name">
              <img src="@/assets/img/chinese/index/con5/icon2.png" alt="icon" />
              <p>구*모 님</p>
            </div>
            <p>당근 중국어로<br />HSKK 5급<br />합격!</p>
            <p>
              일반 시험은 몰라도 중국어 스피킹 시험은 볼 생각도 못 했었는데 이게
              되네요 ㅎㅎ 처음 수업 때는 한 문장도 제대로 못 말했었는데 지금은
              제 생각을 자연스럽게 중국어로 말할 수 있게 되었습니다.
            </p>
          </div>
          <div>
            <div class="icon-name">
              <img src="@/assets/img/chinese/index/con5/icon3.png" alt="icon" />
              <p>윤*혁 님</p>
            </div>
            <p>중국어 덕에<br />원하는 포지션으로<br />이직 성공했어요!</p>
            <p>
              왜 중국어로 말 한마디 하는 게 이렇게 힘들까 항상 고민이었는데,
              당근 중국어로 비즈니스 중국어 회화까지 가능해졌어요. 그 덕에
              원했던 포지션으로 이직에도 성공하고 곧 중국 출장도 다녀올
              예정입니다 :)
            </p>
          </div>
        </VueSlickCarousel>

        <div class="prev-next-arrows">
          <div class="prev" @click="prevSlide">
            <img src="@/assets/img/chinese/index/con5/prev.png" alt="icon" />
          </div>
          <div class="next" @click="nextSlide">
            <img src="@/assets/img/chinese/index/con5/next.png" alt="icon" />
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        arrows: false,
        pauseOnHover: false,
        swipeToSlide: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: "ease-out",
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: false,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1049,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
            },
          },
        ],
      },
      isCarouselInitialized: false,
    };
  },
  methods: {
    handleInit() {
      this.isCarouselInitialized = true;
    },
    prevSlide() {
      if (this.isCarouselInitialized) {
        this.$refs.carousel.prev();
      }
    },
    nextSlide() {
      if (this.isCarouselInitialized) {
        this.$refs.carousel.next();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: calc(100% - 40px);
  margin: 0 auto;

  @media screen and (min-width: 1050px) {
    max-width: 1000px;
  }
}

.con5 {
  padding: 85px 0;
  background-color: #f3f4f6;

  @media screen and (min-width: 1050px) {
    padding: 160px 0;
  }

  > p {
    font-size: 30px;
    font-weight: 700;
    color: #09090b;
    text-align: center;
    margin-bottom: 35px;

    @media screen and (min-width: 1050px) {
      font-size: 50px;
      margin-bottom: 72px;
    }
  }

  .con5-slide {
    :deep(.slick-slider) {
      position: relative;
      margin-bottom: 35px;

      @media screen and (min-width: 1050px) {
        max-width: 1000px;
        margin: 0 auto 48px;
      }

      .slick-list {
        padding-left: 20px;

        @media screen and (min-width: 1050px) {
          padding-left: 0;
        }

        .slick-track {
          display: flex;

          &::before,
          &::after {
            display: none;
          }

          .slick-slide {
            width: 270px;
            @media screen and (min-width: 1050px) {
              height: 452px;
            }

            &:not(:last-child) {
              margin: 0 13px;

              @media screen and (min-width: 1050px) {
                margin: 0 17px;
              }
            }

            > div {
              @media screen and (min-width: 1050px) {
                height: 100%;
              }

              > div {
                @media screen and (min-width: 1050px) {
                  height: 100%;
                }

                padding: 35px 25px;
                background-color: #ffffff;
                border-radius: 28px;

                @media screen and (min-width: 1050px) {
                  padding: 40px 28px;
                  border-radius: 32px;
                }

                .icon-name {
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  margin-bottom: 15px;

                  @media screen and (min-width: 1050px) {
                    gap: 8px;
                    margin-bottom: 20px;
                  }

                  img {
                    width: 28px;

                    @media screen and (min-width: 1050px) {
                      width: 33px;
                    }
                  }

                  p {
                    font-size: 12px;
                    color: #9ca3af;

                    @media screen and (min-width: 1050px) {
                      font-size: 15px;
                    }
                  }
                }

                > p {
                  &:nth-of-type(1) {
                    font-size: 24px;
                    font-weight: 700;
                    color: #374151;
                    line-height: 32px;
                    margin-bottom: 20px;

                    @media screen and (min-width: 1050px) {
                      font-size: 26px;
                      line-height: 35px;
                      margin-bottom: 18px;
                    }
                  }

                  &:nth-of-type(2) {
                    font-size: 14px;
                    color: #6b7280;
                    line-height: 22px;

                    @media screen and (min-width: 1050px) {
                      font-size: 18px;
                      line-height: 28px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .prev-next-arrows {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 31px;

      @media screen and (min-width: 1050px) {
        gap: 46px;
      }
    }

    .prev,
    .next {
      width: 40px;
      cursor: pointer;

      @media screen and (min-width: 1050px) {
        width: 58px;
      }
    }
  }
}
</style>
